import { CodedError } from '../../CodedError';
import { ErrorCodeType, errorCodes } from '../../constants/errorCodes';

/**
 * This class accepts the following error codes:
 * mailchimpInvalidFieldError (default)
 * mailchimpInvalidClientCertificateError
 * mailchimpInvalidCertificatePassphraseError
 * mailchimpClientCertificateValidationError
 */

export class MailChimpInvalidFieldError extends CodedError {
  static get errorName() {
    return this.name;
  }

  constructor(error: ErrorCodeType = errorCodes.mailchimpInvalidFieldError) {
    super(error.message);
    this.code = error.code;
    this.message = `${error.message} ${error.code}`;
    this.name = error.name;
  }
}
